import t from 'tcomb';
import Runtime from './Runtime';

const Behaviour_Ok = t.struct({
  is_good_fellow: t.Bool,
  runtime: Runtime,
  lead_url: t.maybe(t.Str)
}, 'Behaviour_Ok');

module.exports = Behaviour_Ok;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Behaviour_Ok.js
 **/